import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Editor } from '@monaco-editor/react';
import { mask } from '../utils/privacy';



const PreviewDRG = (props) => {

    const { preview, idx, onHover, onHoverLeave } = props;

    const getPrivacyPreview = (privacy) => {

        switch (privacy.method) {
            case "masking":
                return mask("Preview Message", Number(privacy.visible_length), privacy.symbol, privacy.position);
            default:
                return undefined
        }
    };


    return (

        // <PanelGroup className='h-full' direction="horizontal" onMouseEnter={() => onHover(preview.traverse)}>
        <PanelGroup className='h-full' direction="horizontal" onMouseEnter={() => onHover && onHover(preview.traverse)} onMouseLeave={(e) => onHoverLeave && onHoverLeave(e)}>
            <Panel defaultSize={60} >
                <Editor
                    defaultLanguage="sql"
                    value={`${idx !== undefined ? `--Statement ${idx + 1} \n` : ""}${preview.sql_query}`}
                    options={{
                        readOnly: true,
                        minimap: { enabled: false },
                        padding: { top: 15 },
                        wordWrap: "on",
                        lineNumbers: 'off',
                        scrollBeyondLastLine: false
                    }}
                />
            </Panel>
            {preview.privacy.length > 0 && (
                <>
                    <PanelResizeHandle className='w-0.5 bg-slate-300 hover:bg-slate-400' />
                    <Panel minSize={30} maxSize={50}>
                        <div className='h-full p-3 overflow-auto'>
                            <Typography variant='body1'>Privacy</Typography>
                            <Table sx={{ minWidth: 320 }} size="small" aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><Typography variant='subtitle2' className='text-blue-700'>Attribute</Typography></TableCell>
                                        <TableCell><Typography variant='subtitle2' className='text-blue-700'>Method</Typography></TableCell>
                                        <TableCell><Typography variant='subtitle2' className='text-blue-700'>Example</Typography></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {preview.privacy.map((row, idx) =>
                                        <TableRow key={idx}>
                                            <TableCell>{row.attribute.name}</TableCell>
                                            <TableCell>{row.method}</TableCell>
                                            <TableCell>{getPrivacyPreview(row)}</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                    </Panel>
                </>)}
        </PanelGroup>

    );
};

export default PreviewDRG;